// File: src/components/Placementdb/DateRangePicker.jsx
// (or wherever you keep your components)

import { useState, useEffect, useRef } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown } from '@fortawesome/free-solid-svg-icons';

const DateRangePicker = ({ 
    dateFrom, 
    dateTo, 
    onDateFromChange, 
    onDateToChange, 
    label = "Date Range" 
}) => {
    const [isOpen, setIsOpen] = useState(false);
    const containerRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (containerRef.current && !containerRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };

        if (isOpen) {
            document.addEventListener('mousedown', handleClickOutside);
        }

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [isOpen]);

    const formatDateDisplay = () => {
        if (dateFrom && dateTo) {
            return `${dateFrom} to ${dateTo}`;
        } else if (dateFrom) {
            return `From ${dateFrom}`;
        } else if (dateTo) {
            return `To ${dateTo}`;
        }
        return '';
    };

    const clearDates = () => {
        onDateFromChange('');
        onDateToChange('');
    };

    return (
        <div className="multi-select-field" ref={containerRef}>
            <label>{label}:</label>
            <div className="multi-select-container">
                <div className="multi-select-input-wrapper">
                    {(dateFrom || dateTo) && (
                        <div className="selected-tags">
                            <span className="selected-tag">
                                {formatDateDisplay()}
                                <button
                                    type="button"
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        clearDates();
                                    }}
                                    className="tag-remove"
                                >
                                    ×
                                </button>
                            </span>
                        </div>
                    )}
                    <input
                        type="text"
                        className="multi-select-search-input"
                        placeholder="Select date range..."
                        value=""
                        readOnly
                        onClick={() => setIsOpen(!isOpen)}
                        style={{ cursor: 'pointer' }}
                    />
                    <FontAwesomeIcon
                        icon={faChevronDown}
                        className={`dropdown-arrow ${isOpen ? 'open' : ''}`}
                        onClick={(e) => {
                            e.stopPropagation();
                            setIsOpen(!isOpen);
                        }}
                    />
                </div>

                {isOpen && (
                    <div className="multi-select-dropdown" style={{ padding: '15px' }}>
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                            <div>
                                <label style={{ 
                                    display: 'block', 
                                    marginBottom: '5px', 
                                    fontSize: '12px', 
                                    fontWeight: '500' 
                                }}>
                                    From Date:
                                </label>
                                <input
                                    type="date"
                                    value={dateFrom}
                                    onChange={(e) => onDateFromChange(e.target.value)}
                                    max={dateTo || undefined}
                                    style={{ 
                                        width: '100%', 
                                        padding: '8px', 
                                        border: '1px solid #ddd',
                                        borderRadius: '4px',
                                        cursor: 'pointer'
                                    }}
                                />
                            </div>
                            <div>
                                <label style={{ 
                                    display: 'block', 
                                    marginBottom: '5px', 
                                    fontSize: '12px', 
                                    fontWeight: '500' 
                                }}>
                                    To Date:
                                </label>
                                <input
                                    type="date"
                                    value={dateTo}
                                    onChange={(e) => onDateToChange(e.target.value)}
                                    min={dateFrom || undefined}
                                    style={{ 
                                        width: '100%', 
                                        padding: '8px', 
                                        border: '1px solid #ddd',
                                        borderRadius: '4px',
                                        cursor: 'pointer'
                                    }}
                                />
                            </div>
                            <button
                                onClick={() => {
                                    clearDates();
                                    setIsOpen(false);
                                }}
                                style={{
                                    padding: '6px 12px',
                                    backgroundColor: '#f5f5f5',
                                    border: '1px solid #ddd',
                                    borderRadius: '4px',
                                    cursor: 'pointer',
                                    fontSize: '12px',
                                    transition: 'background-color 0.2s'
                                }}
                                onMouseOver={(e) => e.target.style.backgroundColor = '#e8e8e8'}
                                onMouseOut={(e) => e.target.style.backgroundColor = '#f5f5f5'}
                            >
                                Clear Dates
                            </button>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default DateRangePicker;